import axios from 'axios';
import configs from './../config'
import { get } from './../utils/Storage';
import moment from 'moment';

let token = get('token');
let client;

if (token) {
    client = axios.create({
        baseURL: configs.getBaseUrl(),
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
} else {
    client = axios.create({
        baseURL: configs.getBaseUrl(),
    });
}

client.interceptors.request.use(async (config) => {
    config.headers.client = 'web';
    config.headers.clientVersion = configs.getAppVersion()
    config.headers.clientOs = navigator.platform;
    
    const env = configs.getEnv();

    let time = localStorage.getItem('login_time')
    let now = moment();
    let duration = moment.duration(now.diff(time));

    if(config.headers.Authorization != null && config.headers.Authorization != undefined && env != 'local'){
        let pathname = window.location.pathname;
        if (pathname !== '/login') {
            if (duration.asMinutes() < 0) {
                localStorage.setItem('login_time', moment().add(5, 'minutes').toISOString())
            } else {
                localStorage.clear();
                alert('Sua sessão expirou, por favor efetue login novamente')
                window.location.href = '/login'
            }
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default client;
